import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=474128ed&"
import script from "./logout.js?vue&type=script&lang=js&"
export * from "./logout.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports